import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from "../../../Components/api/axiosInstance";

export const createproject = createAsyncThunk("createproject", async (data) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_URL}/vessels/project`,
      data,
    );
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
});

const createProjectSlice = createSlice({
  name: "createproject",
  initialState: {
    createproject: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createproject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createproject.fulfilled, (state, action) => {
        state.loading = false;
        state.addproject = action.payload;
      })
      .addCase(createproject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default createProjectSlice.reducer;
